import type { ReactNode } from 'react';
import { Typography } from 'antd';
import { twMerge } from 'tailwind-merge';

interface BaseErrorProps {
  icon: ReactNode;
  title: string;
  desc: string;
  className?: string;
}

const BaseErrorEcho = ({ icon, title, desc, className }: BaseErrorProps) => {
  return (
    <section
      className={twMerge(
        'bg-[#F0F0F9] flex flex-col items-center justify-center gap-4 text-center text-[#29296B] fill-[#29296B] rounded-md px-4 py-20',
        className
      )}
    >
      <span className="size-8" data-testid="icon">
        {icon}
      </span>
      <div className="flex flex-col gap-2">
      <Typography.Title level={5}>{title}</Typography.Title>
        <Typography.Paragraph className="text-balance">{desc}</Typography.Paragraph>
      </div>
    </section>
  );
};

export default BaseErrorEcho;
